import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {GroupByPipe, OrderByPipe} from "ngx-pipes";
import {GlobalProvider} from "../../providers/global/global";
import {NoteService} from "../../store/note/note.service";

/**
 * Generated class for the SettingNotesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-setting-notes',
  templateUrl: 'setting-notes.html',
  providers: [GroupByPipe, OrderByPipe]
})
export class SettingNotesPage {

  public anmerkungsvorlagen: Array<any> = [];
  public selectedTemplate: any = null;
  // public value: string = "";
  // public category: string = null;
  public editMode: boolean = false;
  public categories: Array<string> = [];

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public noteService: NoteService,
              // private dataProvider: DataProvider,
              private groupByPipe: GroupByPipe,
              public globalProvider: GlobalProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SettingNotesPage');
  }

  public new():void {
    this.selectedTemplate = {title: "", category: ""};
    this.editMode = true;
  }

  public edit(selectedTemplate):void {
    this.selectedTemplate = JSON.parse(JSON.stringify(selectedTemplate));
    this.editMode = true;
  }

  public back():void {
    this.selectedTemplate = null;
    this.editMode = false;
  }

  public save():void {

    if(this.selectedTemplate._id){
      //update
      this.noteService.set(this.selectedTemplate, false);
    }
    else{
      //new
      this.selectedTemplate.docType = 'note';
      this.selectedTemplate.docName = 'Anmerkung';
      this.noteService.add(this.selectedTemplate, false);
    }
    this.selectedTemplate = null;
    this.editMode = false;
  }

  public delete():void {
    // this.dataProvider.hardDeleteDocument(this.selectedTemplate);
    this.noteService.remove(this.selectedTemplate, false);
    this.selectedTemplate = null;
    this.editMode = false;
  }

  public setCategoryName($event){
    this.selectedTemplate.category = $event;
  }

}



// WEBPACK FOOTER //
// ./src/pages/setting-notes/setting-notes.ts